import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import PropTypes from 'prop-types';
var moment = require('moment');

const styles = theme => ({
    root: {
        //width: '100%',
        // height: '100vh', /* Magic here */
        //marginLeft:'28%'

        //margin: '0 auto',
    },
    uploadDocs:{
        marginTop:'20px'
        //margin: '0 auto',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        //justifyContent: 'center',
        margin: '0 Auto',
    },
    margin : {
        marginTop:'40px',
        fontWeight: 'bold'
    },
    row:{
        border:'none',
        fontSize:'13px',
        fontWeight:'normal'
    }
});

class SelectedArbitrators extends Component {
    
    state = {
      AddNoOfDays:0,
      typeOfAccount:localStorage.getItem('typeOfAccount'),
      uniqueId: localStorage.getItem('token')
    };

    componentWillMount(){

    }

    componentDidMount(){
        
    }

    render(){
        const { classes } = this.props;
        console.log('inselectedArbitrators')
        return(
            <div className={classes.root} style={{ marginTop:'30px' }} >

            {
                this.state.typeOfAccount == "admin" && 
                <b style={{marginLeft:'25px'}}>{this.context.t("List of selected arbitrators")}</b>
            }
            <ol>
                {
                    this.state.typeOfAccount == "admin" && 
                    this.props.caseData.selectedArbitrators !== undefined && 
                    this.props.caseData.selectedArbitrators.map((item, index) => (
                    <li>{ 
                        // (''+new Date(item.timestamp)).replace('GMT+0800 (Hong Kong Standard Time)','') 
                        moment(item.timestamp).format('D-MM-YYYY HH:mm:ss') + ' : '+ item.userType +' : '+ item.arbitrator}</li>
                    ))
                }
                {
                    this.state.typeOfAccount == "admin" && 
                    this.props.caseData.selectedArbitrators == undefined &&
                    "--"
                }
            </ol>

            </div>
        
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.uploadDocs.loading,
        files: state.uploadDocs.files,
        userType: state.caseInfo.userType,
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFile: (file, doc_name) => dispatch(actions.addFile(file, doc_name)),
        removeFile: (filename) => dispatch(actions.removeFile(filename)),
        uploadDocs : (files) => dispatch(actions.uploadDocs(files)),
        changeNoOfDays: (caseId, NoOfDays, uniqueId) => dispatch(actions.changeNoOfDays(caseId, NoOfDays, uniqueId))
    }
}

SelectedArbitrators.contextTypes = {
    t: PropTypes.func
  }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SelectedArbitrators));
